module.exports = __webpack_public_path__ + "static/img/default-live-pause.47a4a4bb.png";